/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

// Kept apart from the hooks so views and stories can use them without
// importing the API client (which starts MSAL login on load).

/** Every notifications query starts with this key so they refresh together. */
export const NOTIFICATIONS_QUERY_KEY = ['notifications'] as const;

export const CENTER_PAGE_SIZE = 25;
